export const PRODUCT_CONTAINER_WRAPPER = 'product_container__wrapper';
export const PRODUCTS_GRID_WRAPPER = 'products_grid__wrapper';

export const SORT_FILTER_UID = 'filter[sort]';
